import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {LeaveBlockable} from './leave.blockable';

export class LeaveBlockGuard implements CanDeactivate<LeaveBlockable> {

    canDeactivate(component: LeaveBlockable, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
        | Promise<boolean>
        | boolean {

        if (component.getLeaveBlockComponent().checkAllowedToGo()) {
            return true;
        } else {
            component.getLeaveBlockComponent().showDialogOnNavigateBlock();
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/leave-block/leave.block.guard.ts